module.exports = __webpack_public_path__ + "img/ogatev8-t.9c95f0a7.png";